import { SIDE_BAR_OPTIONS } from '../app/core/components/sidebar/sidebar.component';
import { Environment } from './IEnvironment';

export const environment: Environment = {
  defaultTenant: null,
  apiUrl: 'https://be.fullyops-next.xyz/api/',
  production: false,
  apiGatewayUrl: null,
  hideInternalPermissions: true,
  menuConfigurationHide: {
    supportManagement: {
      hide: false,
      hideSubOption: {
        // [SETTINGS_SUB_OPTION.supportManagement.GENERAL_CONFIGS]: true,
      },
    },
    requestManagement: {
      hide: false,
      hideSubOption: {
        // [SETTINGS_SUB_OPTION.requestManagement.GENERAL_CONFIGS]: true,
      },
    },
    companyManagement: {
      hide: false,
    },
    generalSettings: {
      hide: false,
    },
    languages: {
      disabled: false,
    },
  },
  sideBarConfigurationHide: {},
  test: {
    users: {},
  },
  vapidPublicKey:
    'BD1dE5v9rhcPfc-uB3zLZ39varflCE7yBZ0HIawoePegY811Z6fXgdfo0hJbVSHUcO8Gl3LdaYIRsvLgaJzU4T8',
};
